import { useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { participantsStore } from '../../../../store/participantsStore';
import useOnClickOutside from '../../../../hooks/useOnClickOutside';
import { ReactComponent as CloseIco } from "../../../../assets/icons/close.svg";
import { translationStore } from '../../../../store/translationStore';
import './styles.scss';

const BlockUserModal = observer(({onBlock})=> {
    const ref = useRef()
    const {blockUserModalToggle, user} = participantsStore;
    const {translationData} = translationStore;

    useOnClickOutside(ref, ()=>blockUserModalToggle());

    return (
        <div ref={ref} className='block_user_modal'>
            <div className='header_section'>
                <div></div>
                <p className='mofal_name'>{translationData?.["block_user"] || "Block user"}</p>
                <CloseIco className='close_popup' onClick={()=>blockUserModalToggle()}/>
            </div>
            <p className='modal_description'>{translationData?.["block_user_description"] || "Are you sure you want to block "}{` ${user.name}`}?</p>
            <div className='buttons_section'>
                <div><button className='action_btn' onClick={()=>blockUserModalToggle()}>{translationData?.["cancel"] || "Cancel"}</button></div>
                <div><button className='action_btn block' onClick={onBlock}>{translationData?.["block"] || "Block"}</button></div>
            </div>
        </div>
    )
})

export default BlockUserModal